<template>
    <a-modal
        :visible="true"
        width="60vw"
        :footer="null"
        :closable="false"
        :destroy-on-close="true"
        :maskClosable="false"
        centered
        wrap-class-name="nvp-wrap"
        @cancel="$emit('close')"
    >
        <div class="nvp-modal">
            <div class="nvp-head">
                <div>
                    <h3>{{ initialCnpj ? "Novo vendedor" : "Novo fornecedor" }}</h3>
                    <div class="nvp-sub">{{ stepSubtitle }}</div>
                </div>
                <a-tooltip title="Fechar">
                    <a-button class="nvp-x" @click="$emit('close')">
                        <span class="material-icons-outlined">close</span>
                    </a-button>
                </a-tooltip>
            </div>

            <div class="nvp-steps">
                <div
                    v-for="(item, index) in steps"
                    :key="item.key"
                    class="nvp-step"
                    :class="{ active: step === item.key, done: stepIndex > index }"
                >
                    <span class="nvp-step-dot">
                        <span v-if="stepIndex > index" class="material-icons-outlined">check</span>
                        <template v-else>{{ index + 1 }}</template>
                    </span>
                    <span class="nvp-step-label">{{ item.label }}</span>
                </div>
            </div>

            <div class="nvp-body">
                <template v-if="step === 'cnpj'">
                    <a-form layout="vertical" @submit.prevent="confirmCnpj">
                        <a-form-item
                            label="CNPJ do fornecedor"
                            :validate-status="cnpjError ? 'error' : ''"
                            :help="cnpjError"
                        >
                            <a-input
                                v-model="cnpj"
                                v-mask="'## ### ###/####-##'"
                                placeholder="00 000 000/0000-00"
                                class="nvp-cnpj"
                                @input="cnpjNotFound = false"
                                @pressEnter="confirmCnpj"
                            />
                        </a-form-item>
                    </a-form>
                    <div v-if="cnpjNotFound" class="nvp-notice nvp-notice--warning">
                        <span class="material-icons-outlined">info</span>
                        Esse fornecedor não foi localizado. Deseja continuar com o cadastro?
                    </div>
                </template>

                <template v-else-if="step === 'create'">
                    <div v-if="createError" class="nvp-notice nvp-notice--error">
                        <span class="material-icons-outlined">error_outline</span>
                        {{ createError }}
                    </div>
                    <a-form layout="vertical">
                        <div class="nvp-section-title">Informações da empresa</div>
                        <a-row :gutter="16">
                            <a-col :xs="24" :md="12">
                                <a-form-item label="CNPJ">
                                    <a-input :value="provider.head_office.cnpj | VMask('##.###.###/####-##')" disabled />
                                </a-form-item>
                            </a-col>
                            <a-col :xs="24" :md="12">
                                <a-form-item label="Razão Social">
                                    <a-input v-model="provider.head_office.social_reazon" @change="setSocial" />
                                </a-form-item>
                            </a-col>
                            <a-col :xs="24" :md="12">
                                <a-form-item label="Contato">
                                    <a-input v-model="provider.contact" />
                                </a-form-item>
                            </a-col>
                            <a-col :xs="24" :md="12">
                                <a-form-item label="Nome Fantasia">
                                    <a-input v-model="provider.head_office.trading_name" @change="setFantasyName" />
                                </a-form-item>
                            </a-col>
                        </a-row>

                        <div class="nvp-section-title">Informações da matriz</div>
                        <a-row :gutter="16">
                            <a-col :xs="24" :md="6">
                                <a-form-item label="UF">
                                    <a-select
                                        :value="provider.head_office.state ? provider.head_office.state.est_id : undefined"
                                        show-search
                                        placeholder="UF"
                                        :options="stateOptions"
                                        :filterOption="filterOption"
                                        @change="setState"
                                    />
                                </a-form-item>
                            </a-col>
                            <a-col :xs="24" :md="6">
                                <a-form-item label="CEP">
                                    <a-input v-model="provider.head_office.zip_code" />
                                </a-form-item>
                            </a-col>
                            <a-col :xs="24" :md="12">
                                <a-form-item label="Cidade">
                                    <a-select
                                        :value="provider.head_office.city ? provider.head_office.city.cid_id : undefined"
                                        show-search
                                        placeholder="Cidade"
                                        :disabled="!provider.head_office.state"
                                        :options="cityOptions"
                                        :filterOption="filterOption"
                                        @change="setCity"
                                    />
                                </a-form-item>
                            </a-col>
                            <a-col :xs="24" :md="12">
                                <a-form-item label="Endereço">
                                    <a-input v-model="provider.head_office.street" />
                                </a-form-item>
                            </a-col>
                            <a-col :xs="24" :md="12">
                                <a-form-item label="Bairro">
                                    <a-input v-model="provider.head_office.district" />
                                </a-form-item>
                            </a-col>
                            <a-col :xs="24">
                                <a-form-item label="Complemento">
                                    <a-input v-model="provider.head_office.complement" />
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-form>
                </template>

                <template v-else-if="step === 'seller' && store">
                    <div class="nvp-notice nvp-notice--success">
                        <span class="material-icons-outlined">check_circle</span>
                        {{ createdNow ? "Fornecedor cadastrado com sucesso." : "Esse fornecedor já está cadastrado." }}
                    </div>
                    <div class="nvp-summary">
                        <div><span class="nvp-summary-label">CNPJ</span>{{ store.cnpj | VMask("##.###.###/####-##") }}</div>
                        <div><span class="nvp-summary-label">Nome Fantasia</span>{{ store.nome_fantasia || store.name || "--" }}</div>
                        <div><span class="nvp-summary-label">Razão Social</span>{{ store.razao_social || store.social_reazon || "--" }}</div>
                        <div><span class="nvp-summary-label">Cidade</span>{{ storeCity }}</div>
                        <div><span class="nvp-summary-label">Estado</span>{{ storeState }}</div>
                    </div>

                    <div class="nvp-section-title">Encontre seu vendedor</div>
                    <div v-if="sellerNotFound" class="nvp-notice nvp-notice--warning">
                        <span class="material-icons-outlined">info</span>
                        Vendedor não encontrado. Informe o nome do vendedor para enviar o convite.
                    </div>
                    <a-row :gutter="[12, 12]">
                        <a-col :xs="24" :md="9">
                            <a-input
                                v-model="invitation.receiver_phone"
                                v-mask="'(##) #.####-####'"
                                placeholder="Telefone do vendedor"
                            />
                        </a-col>
                        <a-col :xs="24" :md="9">
                            <a-input
                                v-model="invitation.receiver_name"
                                placeholder="Nome do vendedor"
                                :disabled="!searchedOnce"
                            />
                        </a-col>
                        <a-col :xs="24" :md="6">
                            <a-button type="primary" block :loading="loading" @click="findSeller">
                                {{ searchedOnce ? "Incluir" : "Localizar" }}
                            </a-button>
                        </a-col>
                    </a-row>
                </template>
            </div>

            <div class="nvp-foot">
                <template v-if="step === 'cnpj'">
                    <a-button @click="$emit('close')">Cancelar</a-button>
                    <a-button type="primary" :loading="loading" @click="confirmCnpj">
                        {{ cnpjNotFound ? "Continuar cadastro" : "Confirmar" }}
                    </a-button>
                </template>
                <template v-else-if="step === 'create'">
                    <a-button @click="backToCnpj">Voltar</a-button>
                    <a-button type="primary" :loading="loading" @click="createProvider">Salvar</a-button>
                </template>
                <template v-else>
                    <a-button v-if="!initialCnpj" @click="backToCnpj">Voltar</a-button>
                    <a-button :loading="loading" @click="saveInternalSeller">
                        <i class="fa-solid fa-user-plus nvp-btn-icon"></i> Vendedor interno
                    </a-button>
                </template>
            </div>
        </div>
    </a-modal>
</template>

<script>
import ProfileService from "@/services/v3/providers/profile.service";
import ProviderService from "@/services/v3/provider.service";
import UserService from "@/services/v1/user.service";
import BrasilApiService from "@/services/BrasilApi";
import InvitationService from "@/services/v3/invitation.service";
import QuotationService from "@/services/QuotationService";

const STEPS = [
    { key: "cnpj", label: "CNPJ", subtitle: "Informe o CNPJ do fornecedor" },
    { key: "create", label: "Cadastro", subtitle: "Complete os dados do fornecedor" },
    { key: "seller", label: "Vendedor", subtitle: "Localize ou convide o vendedor" },
];

const onlyDigits = (value) => String(value || "").replace(/[^\d]+/g, "");

const maskCnpj = (value) => onlyDigits(value).replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1 $2 $3/$4-$5");

const newProvider = (cnpj) => ({
    manager: { email: "--", password: String(Math.floor(100000 + Math.random() * 900000)) },
    head_office: { cnpj, email: "--" },
    email: "--",
    delivery_type_id: 2,
    phone: "99999999999",
    settings: [{ key: "CLIENT_RELEASE_STATUS" }],
});

export default {
    name: "AddProviderV2Modal",
    props: {
        initialCnpj: { type: String, default: "" },
    },
    data() {
        return {
            profile_svc: new ProfileService(),
            provider_svc: new ProviderService(),
            user_svc: new UserService(),
            brasil_api: new BrasilApiService(),
            invitation_svc: new InvitationService(),
            quotation_svc: new QuotationService(),
            steps: STEPS,
            step: "cnpj",
            loading: false,
            cnpj: maskCnpj(this.initialCnpj),
            cnpjError: "",
            cnpjNotFound: false,
            provider: newProvider(""),
            states: [],
            cities: [],
            createError: "",
            createdNow: false,
            store: null,
            invitation: null,
            searchedOnce: false,
            sellerNotFound: false,
        };
    },
    computed: {
        stepIndex() {
            return this.steps.findIndex((s) => s.key === this.step);
        },
        stepSubtitle() {
            return this.steps[this.stepIndex].subtitle;
        },
        stateOptions() {
            return this.states.map((s) => ({ value: s.est_id, label: s.est_nome }));
        },
        cityOptions() {
            const state = this.provider.head_office.state;
            if (!state) return [];
            return this.cities.filter((c) => c.est_id == state.est_id).map((c) => ({ value: c.cid_id, label: c.cid_nome }));
        },
        storeCity() {
            const store = this.store || {};
            return store.municipio || (store.head_office && store.head_office.city && store.head_office.city.name) || "--";
        },
        storeState() {
            const store = this.store || {};
            return store.uf || (store.head_office && store.head_office.state && store.head_office.state.name) || "--";
        },
    },
    created() {
        if (this.initialCnpj) this.confirmCnpj();
    },
    methods: {
        filterOption(input, option) {
            const label = option.componentOptions.children[0].text || "";
            return label.toLowerCase().includes(input.toLowerCase());
        },
        backToCnpj() {
            this.step = "cnpj";
            this.cnpjNotFound = false;
            this.createError = "";
        },
        confirmCnpj() {
            if (!this.isValidCnpj(this.cnpj)) {
                this.cnpjError = "CNPJ inválido.";
                return;
            }
            this.cnpjError = "";
            if (this.cnpjNotFound) {
                this.startCreate(onlyDigits(this.cnpj));
                return;
            }
            this.loading = true;
            this.profile_svc
                .load({ name: this.cnpj })
                .then(({ data }) => {
                    if (data.data && data.data.length > 0) this.goToSeller(data.data[0], false);
                    else this.cnpjNotFound = true;
                })
                .catch(() => {
                    this.cnpjError = "Não foi possível consultar o CNPJ.";
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        startCreate(cnpj) {
            this.provider = newProvider(cnpj);
            this.createError = "";
            this.step = "create";
            this.loading = true;
            this.user_svc
                .region_data()
                .then(({ data }) => {
                    this.states = data.estados || [];
                    this.cities = data.cidades || [];
                    return this.fillFromBrasilApi(cnpj);
                })
                .catch(() => {})
                .finally(() => {
                    this.loading = false;
                });
        },
        fillFromBrasilApi(cnpj) {
            return this.brasil_api
                .getCnpjInfo(cnpj)
                .then(({ data }) => {
                    const p = this.provider;
                    this.$set(p, "contact", data.qsa && data.qsa[0] ? data.qsa[0].nome_socio : "");
                    this.$set(p, "phone", data.ddd_telefone_1 || "99999999999");
                    this.$set(p.head_office, "social_reazon", data.razao_social);
                    this.$set(p.head_office, "trading_name", String(data.razao_social || "").replace("LTDA", ""));
                    this.$set(p.head_office, "zip_code", data.cep);
                    this.$set(p.head_office, "street", `${data.logradouro} ${data.numero}`);
                    this.$set(p.head_office, "district", data.bairro);
                    this.$set(p.manager, "name", data.razao_social);
                    this.$set(p.manager, "login", data.razao_social);
                    const state = this.states.find((s) => s.est_sigla == data.uf);
                    if (!state) return;
                    this.$set(p.head_office, "state", { ...state, id: state.est_id });
                    const city = this.cities.find(
                        (c) => c.est_id == state.est_id && String(c.cid_nome).toLowerCase() == String(data.municipio).toLowerCase()
                    );
                    if (city) this.$set(p.head_office, "city", { ...city, id: city.cid_id });
                })
                .catch(() => {});
        },
        setSocial() {
            this.$set(this.provider, "social_reazon", this.provider.head_office.social_reazon);
        },
        setFantasyName() {
            const value = this.provider.head_office.trading_name;
            this.$set(this.provider, "trading_name", value);
            this.$set(this.provider, "name", value);
            this.$set(this.provider.manager, "name", value);
            this.$set(this.provider.manager, "login", value);
        },
        setState(estId) {
            const state = this.states.find((s) => s.est_id == estId);
            this.$set(this.provider.head_office, "state", state ? { ...state, id: state.est_id } : undefined);
            this.$set(this.provider.head_office, "city", undefined);
        },
        setCity(cidId) {
            const city = this.cities.find((c) => c.cid_id == cidId);
            this.$set(this.provider.head_office, "city", city ? { ...city, id: city.cid_id } : undefined);
        },
        createProvider() {
            const { state, city } = this.provider.head_office;
            if (!state || !city) {
                this.createError = "Selecione a UF e a cidade da matriz.";
                return;
            }
            this.createError = "";
            this.loading = true;
            this.provider_svc
                .create(this.provider)
                .then(({ data }) => {
                    const store = { ...data.data, municipio: city.cid_nome, uf: state.est_sigla };
                    this.$emit("saved");
                    this.goToSeller(store, true);
                })
                .catch(() => {
                    this.createError = "Desculpe, não foi possível cadastrar o fornecedor.";
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        goToSeller(store, createdNow) {
            this.store = store;
            this.createdNow = createdNow;
            this.searchedOnce = false;
            this.sellerNotFound = false;
            this.invitation = {
                receiver_company_name: store.nome_fantasia || store.name,
                receiver_name: "",
                receiver_phone: "",
                invited_user_id: null,
                lock: false,
            };
            this.step = "seller";
        },
        findSeller() {
            if (this.searchedOnce) {
                this.sendInvitation();
                return;
            }
            this.loading = true;
            this.provider_svc
                .find_by_phone(this.invitation.receiver_phone)
                .then(({ data }) => {
                    this.invitation = {
                        ...this.invitation,
                        receiver_name: data.usu_nome,
                        receiver_company_name: data.provider.for_nome,
                        invited_user_id: data.usu_id,
                        lock: true,
                    };
                    this.searchedOnce = true;
                    this.sendInvitation();
                })
                .catch(() => {
                    this.searchedOnce = true;
                    this.sellerNotFound = true;
                    this.loading = false;
                });
        },
        sendInvitation() {
            this.loading = true;
            const invitation = { ...this.invitation, cli_id: localStorage.getItem("cli_id") };
            this.invitation_svc
                .send(invitation)
                .then(() => {
                    if (!invitation.invited_user_id) return this.finish("Convite enviado com sucesso!");
                    return this.quotation_svc
                        .enableSeller(invitation.invited_user_id)
                        .then(() => this.finish("Vendedor adicionado com sucesso!"));
                })
                .catch(() => {
                    this.loading = false;
                    this.$swal.fire("Erro!", "Não foi possível enviar o convite.", "error");
                });
        },
        saveInternalSeller() {
            this.$swal
                .fire({
                    title: "Deseja adicionar um vendedor interno?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim, adicionar vendedor!",
                })
                .then((resp) => {
                    if (!resp.isConfirmed) return;
                    const firstName = String(this.store.name || "").split(" ")[0];
                    const payload = {
                        name: firstName,
                        email: "email@email.com",
                        phone: "99",
                        login: Math.floor(Math.random() * 100) + firstName + this.store.cnpj,
                        password: "9268315794",
                        profile: { name: "Vendedor Padrão", id: 753 },
                        provider: this.store,
                    };
                    this.loading = true;
                    return this.invitation_svc
                        .createInternalSeller(payload)
                        .then(({ data }) => this.invitation_svc.activateSeller(data.id, localStorage.getItem("cli_id")))
                        .then(() => this.finish("Vendedor adicionado com sucesso!"))
                        .catch(() => {
                            this.loading = false;
                            this.$swal.fire("Erro!", "Não foi possível adicionar o vendedor interno.", "error");
                        });
                });
        },
        finish(message) {
            this.loading = false;
            this.$emit("saved");
            return this.$swal.fire("Realizado!", message, "success").then(() => this.$emit("close"));
        },
        isValidCnpj(value) {
            const cnpj = onlyDigits(value);
            if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) return false;
            const digit = (size) => {
                let sum = 0;
                let pos = size - 7;
                for (let i = size; i >= 1; i--) {
                    sum += Number(cnpj.charAt(size - i)) * pos--;
                    if (pos < 2) pos = 9;
                }
                return sum % 11 < 2 ? 0 : 11 - (sum % 11);
            };
            return digit(12) === Number(cnpj.charAt(12)) && digit(13) === Number(cnpj.charAt(13));
        },
    },
};
</script>

<style lang="scss" scoped>
.nvp-modal {
    max-height: 88vh;
    background: #fff;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.nvp-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 18px 20px 14px;

    h3 {
        font-size: 16px;
        font-weight: 600;
        color: #262626;
    }
}
.nvp-sub {
    font-size: 13px;
    color: #8c8c8c;
    margin-top: 2px;
}
.nvp-x.ant-btn,
.nvp-x.ant-btn:focus,
.nvp-x.ant-btn:active {
    width: 28px;
    height: 28px;
    padding: 0;
    border: none;
    background: none;
    border-radius: 6px;
    color: #8c8c8c;
    box-shadow: none;
    display: flex;
    align-items: center;
    justify-content: center;
}
.nvp-x.ant-btn:hover {
    background: #f0f0f0;
    color: #262626;
}
.nvp-steps {
    display: flex;
    gap: 24px;
    padding: 0 20px 14px;
}
.nvp-step {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #bfbfbf;
    font-size: 13px;
}
.nvp-step-dot {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 1px solid #d9d9d9;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 600;

    .material-icons-outlined {
        font-size: 16px;
    }
}
.nvp-step.active {
    color: #262626;
    font-weight: 600;

    .nvp-step-dot {
        border-color: var(--primary-color);
        background: var(--primary-color);
        color: #fff;
    }
}
.nvp-step.done {
    color: #595959;

    .nvp-step-dot {
        border-color: var(--primary-color);
        color: var(--primary-color);
    }
}
.nvp-body {
    flex: 1;
    overflow-y: auto;
    padding: 16px 20px;
    border-top: 1px solid #f0f0f0;
    min-height: 200px;
}
.nvp-cnpj {
    max-width: 320px;
}
.nvp-section-title {
    font-weight: 600;
    font-size: 14px;
    color: #262626;
    margin: 4px 0 10px;
}
.nvp-notice {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border-radius: 8px;
    font-size: 13px;
    margin-bottom: 12px;

    .material-icons-outlined {
        font-size: 18px;
    }
}
.nvp-notice--success {
    background: #f6ffed;
    border: 1px solid #b7eb8f;
    color: #389e0d;
}
.nvp-notice--warning {
    background: #fffbe6;
    border: 1px solid #ffe58f;
    color: #ad6800;
}
.nvp-notice--error {
    background: #fff1f0;
    border: 1px solid #ffa39e;
    color: #cf1322;
}
.nvp-summary {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 8px 16px;
    padding: 12px 14px;
    margin-bottom: 16px;
    background: #fafafa;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    font-size: 13px;
    color: #262626;
}
.nvp-summary-label {
    display: block;
    font-size: 12px;
    color: #8c8c8c;
}
.nvp-btn-icon {
    margin-right: 6px;
}
.nvp-foot {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 14px 20px;
    border-top: 1px solid #f0f0f0;
}
</style>

<style lang="scss">
.nvp-wrap {
    .ant-modal {
        min-width: 560px;
        max-width: 95vw;
    }

    .ant-modal-content {
        padding: 0;
        border-radius: 10px;
        overflow: hidden;
    }

    .ant-modal-body {
        padding: 0;
    }
}
</style>
